import { render, staticRenderFns } from "./RecipeImportPage.vue?vue&type=template&id=944439ec&"
import script from "./RecipeImportPage.vue?vue&type=script&lang=js&"
export * from "./RecipeImportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports